import { useRef } from "react";
import { useTranslation } from "react-i18next";
import Airfreight from "../components/Services/Airfreight";
import Aerospace from "../components/Services/Aerospace";
import DiplomaticCargo from "../components/Services/DiplomaticCargo";
import Roadfreight from "../components/Services/Roadfreight";
import DangerousGoods from "../components/Services/DangerousGoods";
import TimeCritical from "../components/Services/TimeCritical";
import Oceanfreight from "../components/Services/Oceanfreight";
import ShipSpares from "../components/Services/ShipSpares";
import shipLogistics from "../images/shipLogistics.png";
import aboutUs from "../images/aboutUs.jpg";
import blackJet from "../images/blackJet.jpg";
import containers from "../images/containers.jpg";
import diplomaticPouch from "../images/diplomaticPouch.jpg";
import engine from "../images/engine.jpg";
import fragile from "../images/fragile.jpg";
import helicopter from "../images/helicopter.jpg";
import truck from "../images/truck.jpg";
import AboutUs from "../components/Services/AboutUs";
import ContactUs from "../components/Services/ContactUs";
import type { Section } from "../types/Section";

const useSections = (isSmallScreen: boolean) => {
  const aboutUsRef = useRef<HTMLDivElement>(null);
  const airfreightRef = useRef<HTMLDivElement>(null);
  const aerospaceRef = useRef<HTMLDivElement>(null);
  const diplomaticCargoRef = useRef<HTMLDivElement>(null);
  const roadfreightRef = useRef<HTMLDivElement>(null);
  const dangerousGoodsRef = useRef<HTMLDivElement>(null);
  const timeCriticalRef = useRef<HTMLDivElement>(null);
  const oceanFreightRef = useRef<HTMLDivElement>(null);
  const shipSparesRef = useRef<HTMLDivElement>(null);
  const contactUsRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  const sections: Section[] = [
    {
      ref: airfreightRef,
      subject: t("airfreight.subject"),
      alt: t("airfreight.image-alt"),
      description: <Airfreight />,
      image: blackJet,
    },
    {
      ref: aerospaceRef,
      subject: t("aerospace.subject"),
      alt: t("aerospace.image-alt"),
      description: <Aerospace />,
      image: engine,
    },
    {
      ref: timeCriticalRef,
      subject: t("time-critical.subject"),
      alt: t("time-critical.image-alt"),
      description: <TimeCritical />,
      image: fragile,
    },
    {
      ref: shipSparesRef,
      subject: t("ship-spares.subject"),
      alt: t("ship-spares.image-alt"),
      description: <ShipSpares />,
      image: shipLogistics,
    },
    {
      ref: dangerousGoodsRef,
      subject: t("dangerous-goods.subject"),
      alt: t("dangerous-goods.image-alt"),
      description: <DangerousGoods />,
      image: helicopter,
    },
    {
      ref: diplomaticCargoRef,
      subject: t("diplomatic-cargo.subject"),
      alt: t("diplomatic-cargo.image-alt"),
      description: <DiplomaticCargo />,
      image: diplomaticPouch,
    },
    {
      ref: roadfreightRef,
      subject: t("roadfreight.subject"),
      alt: t("roadfreight.image-alt"),
      description: <Roadfreight />,
      image: truck,
    },
    {
      ref: oceanFreightRef,
      subject: t("oceanfreight.subject"),
      alt: t("oceanfreight.image-alt"),
      description: <Oceanfreight />,
      image: containers,
    },
  ];

  if (isSmallScreen) {
    sections.splice(0, 0, {
      ref: aboutUsRef,
      subject: t("about-us.subject"),
      description: <AboutUs />,
      image: aboutUs,
    });
    sections.push({
      ref: contactUsRef,
      subject: t("contact-us.subject"),
      description: <ContactUs />,
    });
  }

  return { sections, aboutUsRef, aerospaceRef, contactUsRef };
};

export default useSections;
